import Chance from 'chance';
import { Caracterizacao } from './types/caracterizacao.types';
const chance = new Chance();

export const ESTABILSHMENT_INIT_STATE = {
  idEstabelecimento: chance.integer({ min: 100000, max: 999999 }),
  cnesEstabelecimento: chance.string({ length: 7, numeric: true }),
  nomeFantasiaEstabelecimento: chance.company(),
  idRascunho: chance.integer({ min: 100000, max: 999999 }),
  cnesRascunho: chance.string({ length: 7, numeric: true }),
  nomeFantasiaRascunho: chance.company(),
  controleAlteracaoRascunho: {
    id: chance.integer({ min: 100, max: 999 }),
    dataInclusao: chance.date({ string: true, american: false }),
    tipoEstabelecimento: {
      codigo: chance.string({ length: 3, numeric: true }),
    },
    perfilUsuario: chance.pickone([
      'Administrador Federal',
      'Administrador Estadual',
      'Administrador Municipal',
    ]),
    esferaUsuario: chance.pickone(['BRASIL', 'ESTADO', 'MUNICÍPIO']),
    statusCadastro: chance.pickone(['1', '2', '3']),
  },
};

const geralColsDefault = [
  {
    key: 'grupoAtividadeSecundaria',
    title: 'Grupo da Atividade Secundária',
  },
  {
    key: 'atividadeSecundaria',
    title: 'Atividade Secundária',
  },
];

const geralConvenioColsDefault = [
  {
    key: 'descricaoConvenio',
    title: 'Convênio',
  },
];

const geralNivelAtencaoColsDefault = [
  {
    key: 'descricaoTipo',
    title: 'Tipo',
  },
  {
    key: 'descricaoComplexidade',
    title: 'Complexidade',
  },
  {
    key: 'descricaoGestao',
    title: 'Gestão',
  },
];

const servisColsDefault = [
  {
    key: 'servicoDescricao',
    title: 'Serviço',
  },
  {
    key: 'classificacaoServicoDescricao',
    title: 'Classificação',
  },
  {
    key: 'prestadoPorDescricao',
    title: 'Prestado por',
  },
  {
    key: 'actions',
    title: 'Ações',
  },
];

export const CARACTERIZACAO_INIT_TABLE = {
  geral: {
    added: {
      atividadesSecundarias: {
        data: [],
        cols: geralColsDefault,
      },
      niveisAtencao: {
        data: [],
        cols: geralNivelAtencaoColsDefault,
      },
      convenios: {
        data: [],
        cols: geralConvenioColsDefault,
      },
    },
    updated: {
      atividadesSecundarias: {
        data: [],
        cols: geralColsDefault,
      },
      niveisAtencao: {
        data: [],
        cols: geralNivelAtencaoColsDefault,
      },
      convenios: {
        data: [],
        cols: geralConvenioColsDefault,
      },
    },
    deleted: {
      atividadesSecundarias: {
        data: [],
        cols: geralColsDefault,
      },
      niveisAtencao: {
        data: [],
        cols: geralNivelAtencaoColsDefault,
      },
      convenios: {
        data: [],
        cols: geralConvenioColsDefault,
      },
    },
  },
  servicos: {
    added: {
      items: {
        data: [],
        cols: servisColsDefault,
      },
    },
    updated: {
      items: {
        data: [],
        cols: servisColsDefault,
      },
    },
    deleted: {
      items: {
        data: [],
        cols: servisColsDefault,
      },
    },
  },
};

function getFakeService(ids: number[]) {
  let i = 0;

  let items = chance.n(() => {
    const id = ids[i];
    i++;
    return {
      id: id,
      classificacaoServico: {
        id: chance.integer({ min: 1, max: 999 }),
        codigo: chance.string({ pool: '1234567890', length: 3 }),
        descricao: chance.sentence({ words: 5 }),
        servico: {
          codigo: chance.string({ pool: '1234567890', length: 3 }),
          descricao: chance.sentence({ words: 5 }),
          ativo: chance.bool(),
        },
        ativo: chance.bool(),
      },
      atendimentoSUS: {
        codigo: chance.string({ pool: '1234567890', length: 1 }),
        descricao: chance.word(),
      },
      prestadoPor: {
        codigo: chance.string({ pool: '1234567890', length: 1 }),
        descricao: chance.word(),
      },
      enderecosComplementares: chance.n(() => {
        return {
          id: chance.integer({ min: 1, max: 9999 }),
          identificacao: chance.sentence({ words: 3 }),
          numeroEndereco: chance.integer({ min: 1, max: 999 }).toString(),
          complemento: chance.sentence({ words: 2 }),
          logradouro: chance.street(),
          cep: chance.postcode(),
          codigoMunicipioIBGE: chance.string({ pool: '1234567890', length: 6 }),
          nomeMunicipio: chance.city(),
          siglaUf: chance.state({ full: false }),
          codigoUf: chance.string({ pool: '1234567890', length: 2 }),
          dddTelefone: chance.string({ pool: '1234567890', length: 2 }),
          telefone: chance.phone({ formatted: false }),
          dataAtivacao: chance.date({
            string: true,
            american: false,
            year: 2023,
          }),
          dataDesativacao: chance.date({
            string: true,
            american: false,
            year: 2023,
          }),
          bairro: chance.province(),
        };
      }, chance.integer({ min: 1, max: 5 })),
    };
  }, chance.integer({ min: 1, max: 5 }));

  return items;
}

function getFakeServiceNullableFake(ids: number[]) {
  const nullableFake = (fakeValue) => (chance.bool() ? fakeValue : null);
  let i = 0;

  let items = chance.n(() => {
    const id = ids[i];
    i++;
    return {
      id,
      classificacaoServico: {
        id: chance.integer({ min: 1, max: 999 }),
        codigo: chance.string({ pool: '1234567890', length: 3 }),
        descricao: chance.sentence({ words: 5 }),
        servico: {
          codigo: chance.string({ pool: '1234567890', length: 3 }),
          descricao: chance.sentence({ words: 5 }),
          ativo: chance.bool(),
        },
        ativo: chance.bool(),
      },
      atendimentoSUS: {
        codigo: chance.string({ pool: '1234567890', length: 1 }),
        descricao: chance.word(),
      },
      prestadoPor: {
        codigo: chance.string({ pool: '1234567890', length: 1 }),
        descricao: chance.word(),
      },
      enderecosComplementares: nullableFake(
        chance.n(() => {
          return {
            id: chance.integer({ min: 1, max: 9999 }),
            identificacao: chance.sentence({ words: 3 }),
            numeroEndereco: chance.integer({ min: 1, max: 999 }).toString(),
            complemento: chance.sentence({ words: 2 }),
            logradouro: chance.street(),
            cep: chance.postcode(),
            codigoMunicipioIBGE: chance.string({
              pool: '1234567890',
              length: 6,
            }),
            nomeMunicipio: chance.city(),
            siglaUf: chance.state({ full: false }),
            codigoUf: chance.string({ pool: '1234567890', length: 2 }),
            dddTelefone: chance.string({ pool: '1234567890', length: 2 }),
            telefone: chance.phone({ formatted: false }),
            dataAtivacao: chance.date({
              string: true,
              american: false,
              year: 2023,
            }),
            dataDesativacao: chance.date({
              string: true,
              american: false,
              year: 2023,
            }),
            bairro: chance.province(),
          };
        }, chance.integer({ min: 1, max: 5 }))
      ),
    };
  }, chance.integer({ min: 1, max: 15 }));

  return items;
}

const getFakeGeneral = () => {
  const days = [
    'SEGUNDA_FEIRA',
    'TERÇA_FEIRA',
    'QUARTA_FEIRA',
    'QUINTA_FEIRA',
    'SEXTA_FEIRA',
    'SÁBADO',
    'DOMINGO',
  ];

  return {
    grupoAtividadePrincipal: chance.word(),
    atividadePrincipal: chance.word(),
    tipoEstabelecimento: chance.word(),
    atividadesSecundarias: Array.from(
      { length: chance.integer({ min: 1, max: 3 }) },
      () => ({
        idGrupoAtividadeSecundaria: chance.integer(),
        grupoAtividadeSecundaria: chance.sentence({ words: 3 }),
        atividadeSecundaria: chance.sentence({ words: 5 }),
      })
    ),
    niveisAtencao: Array.from(
      { length: chance.integer({ min: 1, max: 2 }) },
      () => ({
        idTipo: chance.integer(),
        descricaoTipo: chance.word(),
        idComplexidade: chance.integer(),
        descricaoComplexidade: chance.word(),
        idGestao: chance.integer(),
        descricaoGestao: chance.word(),
      })
    ),
    convenios: Array.from(
      { length: chance.integer({ min: 1, max: 2 }) },
      () => ({
        idConvenio: chance.integer(),
        descricaoConvenio: chance.company(),
      })
    ),
    possuiContratoSus: chance.bool(),
    formaAcesso: chance.sentence({ words: 3 }),
    sempreAberto: chance.bool(),
    horariosAtendimento: Array.from(
      { length: chance.integer({ min: 1, max: 3 }) },
      () => ({
        diaSemana: {
          codigo: chance.string({ length: 2, numeric: true }),
          descricao: chance.pickone(days),
        },
        horarioInicio: `${chance.hour({
          twentyfour: true,
        })}:${chance.minute()}`,
        horarioFim: `${chance.hour({ twentyfour: true })}:${chance.minute()}`,
      })
    ),
  };
};

const getFakeGeneralNullableFake = () => {
  const days = [
    'SEGUNDA_FEIRA',
    'TERÇA_FEIRA',
    'QUARTA_FEIRA',
    'QUINTA_FEIRA',
    'SEXTA_FEIRA',
    'SÁBADO',
    'DOMINGO',
  ];

  const nullableFake = (fakeValue) => (chance.bool() ? fakeValue : null);

  return {
    grupoAtividadePrincipal: nullableFake(chance.word()),
    atividadePrincipal: nullableFake(chance.word()),
    tipoEstabelecimento: nullableFake(chance.word()),
    atividadesSecundarias: nullableFake(
      Array.from({ length: chance.integer({ min: 1, max: 5 }) }, () => ({
        idGrupoAtividadeSecundaria: chance.integer(),
        grupoAtividadeSecundaria: chance.sentence({ words: 3 }),
        atividadeSecundaria: chance.sentence({ words: 5 }),
      }))
    ),
    niveisAtencao: nullableFake(
      Array.from({ length: chance.integer({ min: 1, max: 5 }) }, () => ({
        idTipo: chance.integer(),
        descricaoTipo: chance.word(),
        idComplexidade: chance.integer(),
        descricaoComplexidade: chance.word(),
        idGestao: chance.integer(),
        descricaoGestao: chance.word(),
      }))
    ),
    convenios: nullableFake(
      Array.from({ length: chance.integer({ min: 1, max: 5 }) }, () => ({
        idConvenio: chance.integer(),
        descricaoConvenio: chance.company(),
      }))
    ),
    possuiContratoSus: nullableFake(chance.bool()),
    formaAcesso: nullableFake(chance.sentence({ words: 3 })),
    sempreAberto: nullableFake(chance.bool()),
    horariosAtendimento: nullableFake(
      Array.from({ length: chance.integer({ min: 1, max: 5 }) }, () => ({
        diaSemana: {
          codigo: chance.string({ length: 2, numeric: true }),
          descricao: chance.pickone(days),
        },
        horarioInicio: `${chance.hour({
          twentyfour: true,
        })}:${chance.minute()}`,
        horarioFim: `${chance.hour({ twentyfour: true })}:${chance.minute()}`,
      }))
    ),
  };
};

const caracterizacaoMock = () => {
  const ids = Array.from({ length: 15 }, () =>
    chance.integer({ min: 1, max: 9999 })
  );

  return {
    code: 200,
    paginado: false,
    status: chance.pickone(['1', '2', '3']),
    records: {
      geral: {
        added: getFakeGeneral(),
        updated: getFakeGeneralNullableFake(),
        deleted: getFakeGeneralNullableFake(),
      },
      servicos: {
        added: {
          items: getFakeService(ids),
        },
        updated: {
          items: getFakeServiceNullableFake(ids),
        },
        deleted: {
          items: getFakeServiceNullableFake(ids),
        },
      },
    },
  };
};

export const CARACTERIZACAO_INIT_STATE: Caracterizacao = caracterizacaoMock();
